import api from "../globals/axios";
import {
  FARMS_ENDPONIT,
} from "../globals/endpoints";

export async function getFarmerFarms() {
  const response = await api.get(FARMS_ENDPONIT);
  return response.data;
};
